import { Vec3 } from 'cc';
import ControlPointPair from './ControlPointPair';
import SplineInterpolator from './SplineInterpolator';

// 一段曲線的物件  (多段連續的曲線組合 => Path)
export default class CurveData {
    private _startPair: ControlPointPair;
    private _destinationPair: ControlPointPair;
    private _arcLength: number;

    constructor(startPair: ControlPointPair, destinationPair: ControlPointPair) {
        this._startPair = startPair;
        this._destinationPair = destinationPair;
        this._arcLength = 0;
    }

    public get targetPair() {
        return this._destinationPair;
    }

    /**
     * 表演長度 (單位：幀)
     * @returns {number}
     */
    public get duration() {
        return this._arcLength;
    }

    public get arcLength(): number {
        return this._arcLength;
    }

    public compute(segment: number) {
        const point0: Vec3 = this._startPair.points[1];
        const point1: Vec3 = this._startPair.points[0];
        const point2: Vec3 = this._destinationPair.points[2];
        const point3: Vec3 = this._destinationPair.points[1];
        const interpolationPoints = SplineInterpolator.bezierCurveInterpolation(point0, point1, point2, point3, segment);
        this._arcLength = SplineInterpolator.getArcLength(interpolationPoints);
    }
}
